// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"133":"4d03937bdb871ea7","382":"78ca9d6ad0c32715"}[chunkId] + ".js";
};